import styled from 'styled-components';
import { breakpointLG } from '../styles/breakpoints';
export const Wrapper = styled.div({
    display: 'flex',
    [`@media (min-width: ${breakpointLG})`]: {
        display: 'none',
    },
    '.MuiButtonBase-root': {
        height: 56,
        width: 56,
        '.closeIcon': {
            height: 24,
            width: 24,
        },
        '.hamburgerIcon': {
            height: 56,
            width: 56,
        },
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    '.iconButton': {
        marginRight: '-16px',
    },
});
//# sourceMappingURL=styles.js.map